import { AlertTriangle } from "lucide-react";

export function BankruptWarning({ hit }) {
  return (
    <div role="alert" data-testid="jr-bankrupt-warning"
      className="relative mb-6 mx-auto max-w-md flex items-start gap-3 rounded-2xl bg-red-600/90 ring-2 ring-red-400/70 px-4 py-3 text-left text-white shadow-[0_0_28px_rgba(220,38,38,.55)] jr-warn">
      <AlertTriangle className="w-6 h-6 shrink-0 mt-0.5 text-yellow-200" />
      <p className="text-sm leading-snug font-semibold">
        <span className="block font-display text-base font-black tracking-wide">{hit ? "BANKROTT GETROFFEN!" : "ACHTUNG: BANKROTT"}</span>
        {hit ? "Der Jackpot ist für diese Woche beendet – niemand gewinnt ihn." : "Trifft ein Spieler BANKROTT, ist der Jackpot für diese Woche beendet und niemand gewinnt."}
      </p>
    </div>
  );
}
